export function reorderArray(arr, fromIndex, toIndex) {
    const arrLength = arr.length;
    if (fromIndex < 0 || fromIndex >= arrLength || toIndex < 0 || toIndex >= arrLength) {
        return arr;
    }

    const elementToMove = arr.splice(fromIndex, 1)[0];
    arr.splice(toIndex, 0, elementToMove);

    return arr;
}
